'use client';
import { useEffect, useRef } from 'react';

/**
 * Types
 */
type Props = {
  showVersion?: boolean;
};

/**
 * Component: AppVersion
 */
export default function AppVersion({ showVersion }: Props) {
  const isRendered = useRef(false);

  useEffect(() => {
    if (isRendered.current) return;
    console.log('%cversion: %s', 'font-size:1rem;font-weight:bold;', process.env.appVersion);
    isRendered.current = true;
  }, []);

  if (showVersion) return <div className="relative z-10 p-1 text-center text-xs">v{process.env.appVersion}</div>;
  return null;
}
